import React from 'react'
import styles from './styles/btn-toggle.module.scss'
import classNames from 'classnames'

interface BtnToggleProps {
  onClick?: () => any
  isActive?: boolean
  className?: string
}

const BtnToggle: React.FC<BtnToggleProps> = ({
  onClick,
  children,
  isActive = false,
  className = '',
}) => {
  return (
    <button
      type='button'
      className={classNames(styles.btnToggle, {
        [styles.active]: isActive,
        [className]: !!className,
      })}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default BtnToggle
